import { z } from 'zod';
export const procurementOperationIdSchema = z.string().uuid();
export const procurementOperationReasonSchema = z.string().trim().min(10).max(500);
export const procurementOperationMoneyCentsSchema = z.number().int().min(0).max(999_999_999_999);
export const procurementOperationSignedMoneyCentsSchema = z.number().int().min(-999_999_999_999).max(999_999_999_999);
export const procurementOperationQuantityTenThousandthsSchema = z.number().int().min(0).max(10_000_000_000);
export const procurementOperationProgressBasisPointsSchema = z.number().int().min(0).max(10_000);
export const procurementOperationCurrencyCodeSchema = z.string().regex(/^[A-Z]{3}$/);
export const procurementOperationSourceReferenceSchema = z.strictObject({
    capability: z.string().regex(/^[a-z][a-z0-9-]*(?:\.[a-z0-9-]+)+\.v[1-9][0-9]*$/),
    sourceId: z.string().trim().min(1).max(240),
    label: z.string().trim().min(1).max(240),
}).nullable();
export const procurementOperationCounterpartySchema = z.strictObject({
    displayName: z.string().trim().min(1).max(240),
    relationshipOrganizationId: z.string().uuid().nullable(),
    relationshipContactId: z.string().uuid().nullable(),
    phone: z.string().trim().max(80).nullable(),
    email: z.string().trim().email().max(320).nullable(),
});
export const procurementOperationPageSchema = z.strictObject({
    limit: z.number().int().positive(),
    offset: z.number().int().nonnegative(),
    returned: z.number().int().nonnegative(),
    total: z.number().int().nonnegative(),
});
export const procurementOperationStateCommandSchema = z.strictObject({
    kind: z.enum(['archive', 'restore']),
    commandId: z.string().uuid(),
    expectedRevision: z.number().int().positive(),
    reason: procurementOperationReasonSchema,
});
//# sourceMappingURL=procurement-operation-common.contract.js.map